import React from "react";
import Profiles from "../modules/profiles/profile-list/ProfileListContainer";

const ProfileListPage: React.FC = () => {
  return <Profiles />;
};

export default ProfileListPage;
